function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.0156 2.01465C13.5679 2.01465 14.0156 2.46236 14.0156 3.01465V8.0341C14.0156 8.58638 14.4633 9.0341 15.0156 9.0341C15.5679 9.0341 16.0156 8.58638 16.0156 8.0341V3.01465C16.0156 1.35779 14.6725 0.0146484 13.0156 0.0146484H3.01562C1.35877 0.0146484 0.015625 1.35779 0.015625 3.01465V17.0146C0.015625 18.6715 1.35877 20.0146 3.01562 20.0146H6.50073C7.05301 20.0146 7.50073 19.5669 7.50073 19.0146C7.50073 18.4624 7.05301 18.0146 6.50073 18.0146H3.01562C2.46334 18.0146 2.01562 17.5669 2.01562 17.0146V3.01465C2.01562 2.46236 2.46334 2.01465 3.01562 2.01465H13.0156Z",
  fill: "#121212"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.00073 4.99975C4.44844 4.99975 4.00073 5.44747 4.00073 5.99975C4.00073 6.55204 4.44844 6.99975 5.00073 6.99975H11.0007C11.553 6.99975 12.0007 6.55204 12.0007 5.99975C12.0007 5.44747 11.553 4.99975 11.0007 4.99975H5.00073Z",
  fill: "#121212"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.00083 9.99975C4.00083 9.44747 4.44855 8.99975 5.00083 8.99975H9.00083C9.55312 8.99975 10.0008 9.44747 10.0008 9.99975C10.0008 10.552 9.55312 10.9998 9.00083 10.9998H5.00083C4.44855 10.9998 4.00083 10.552 4.00083 9.99975Z",
  fill: "#121212"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.76 11.6505C20.1194 11.2312 20.0709 10.5999 19.6515 10.2405C19.2322 9.88107 18.6009 9.92963 18.2415 10.349L12.9443 16.5291L11.2078 14.7926C10.8173 14.4021 10.1841 14.4021 9.79363 14.7926C9.4031 15.1832 9.4031 15.8163 9.79363 16.2069L12.2936 18.7069C12.4906 18.9038 12.7608 19.0097 13.0391 18.999C13.3174 18.9883 13.5787 18.862 13.76 18.6505L19.76 11.6505Z",
  fill: "#121212"
});

function SvgAction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAction);
export default __webpack_public_path__ + "static/media/Action.2a55ce25.svg";
export { ForwardRef as ReactComponent };